<form [formGroup]="form" (ngSubmit)="submit()">
  <header class="dialog-heading">
    <span><mat-icon>{{ isPerson ? 'person' : 'business' }}</mat-icon></span>
    <div>
      <h2 mat-dialog-title>{{ data.entry ? 'Kontakt bearbeiten' : 'Kontakt anlegen' }}</h2>
      <p>Personen und Organisationen werden eindeutig getrennt gespeichert.</p>
    </div>
  </header>

  <mat-dialog-content>
    @if (errorMessage) { <div class="dialog-error" role="alert">{{ errorMessage }}</div> }

    <mat-radio-group formControlName="type" aria-label="Kontakttyp">
      <mat-radio-button value="PERSON">Person</mat-radio-button>
      <mat-radio-button value="ORGANISATION">Organisation</mat-radio-button>
    </mat-radio-group>

    @if (isPerson) {
      <section class="form-section">
        <h3>Person</h3>
        <div class="identity-grid person-grid">
          <mat-form-field appearance="outline"><mat-label>Anrede</mat-label><input matInput formControlName="title" maxlength="255"></mat-form-field>
          <mat-form-field appearance="outline"><mat-label>Vorname (optional)</mat-label><input matInput formControlName="firstName" maxlength="255"><mat-error>Der Vorname ist zu lang.</mat-error></mat-form-field>
          <mat-form-field appearance="outline"><mat-label>Nachname</mat-label><input matInput formControlName="lastName" maxlength="255"><mat-error>Nachname ist erforderlich.</mat-error></mat-form-field>
        </div>
        <app-address-book-address-fields [group]="form.controls['personAddress']" legend="Adresse"></app-address-book-address-fields>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Zugehörige Organisationen</mat-label>
          <textarea matInput formControlName="organisations" rows="2"></textarea>
          <mat-hint>Eine Organisation pro Zeile</mat-hint>
        </mat-form-field>
      </section>
    } @else {
      <section class="form-section">
        <h3>Organisation</h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Organisationsname</mat-label><input matInput formControlName="organisationName" maxlength="255">
          <mat-error>Organisationsname ist erforderlich.</mat-error>
        </mat-form-field>
        <app-address-book-address-fields [group]="form.controls['businessAddress']" legend="Geschäftsadresse"></app-address-book-address-fields>
        <app-address-book-address-fields [group]="form.controls['legalAddress']" legend="Rechtliche Adresse"></app-address-book-address-fields>
      </section>
    }

    <section class="form-section">
      <h3>Digitale Kontaktdaten</h3>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Telefonnummern</mat-label>
        <textarea matInput formControlName="phoneNumbers" rows="3" placeholder="+49 | 202 123456"></textarea>
        <mat-hint>Eine Nummer pro Zeile: Ländervorwahl | Nummer</mat-hint>
        @if (form.controls['phoneNumbers'].hasError('phoneNumbers')) { <mat-error>Format: +49 | 202 123456</mat-error> }
      </mat-form-field>
      <div class="digital-grid">
        <mat-form-field appearance="outline">
          <mat-label>E-Mail-Adressen</mat-label><textarea matInput formControlName="emails" rows="3"></textarea>
          <mat-hint>Eine Adresse pro Zeile</mat-hint>
          @if (form.controls['emails'].hasError('emails')) { <mat-error>Mindestens eine E-Mail-Adresse ist ungültig.</mat-error> }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Webseiten</mat-label><textarea matInput formControlName="websites" rows="3" placeholder="https://example.org"></textarea>
          <mat-hint>Eine vollständige URL pro Zeile</mat-hint>
          @if (form.controls['websites'].hasError('websites')) { <mat-error>Nur vollständige HTTP(S)-URLs sind gültig.</mat-error> }
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Dezentrale Identifikatoren (DIDs)</mat-label>
        <textarea matInput formControlName="dids" rows="3" placeholder="did:web:example.org"></textarea>
        <mat-hint>Ein DID pro Zeile</mat-hint>
      </mat-form-field>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" [disabled]="submitting" (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || submitting">
      @if (submitting) { <mat-spinner diameter="18"></mat-spinner> } @else { <mat-icon>save</mat-icon> }
      Speichern
    </button>
  </mat-dialog-actions>
</form>
